import { buildCloudFrontUrl, getFilenameFromPath, isAbsoluteUrl } from './pathUtils';

export const urlToFile = async (url: string): Promise<File> => {
    const fileUrl = isAbsoluteUrl(url) ? url : buildCloudFrontUrl(url, false);
    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const filename = getFilenameFromPath(fileUrl);

    return new File([blob], filename, { type: blob.type });
};
